// extracted by mini-css-extract-plugin
export default {"b-icon-warning":"TitlePage_style_b-icon-warning__udmvv","titlePage":"TitlePage_style_titlePage__H+wFT","rotate":"TitlePage_style_rotate__PDAEG"};